import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=82c9f77e&scoped=true&"
import script from "./SortIcon.vue?vue&type=script&lang=js&"
export * from "./SortIcon.vue?vue&type=script&lang=js&"
import style0 from "./SortIcon.vue?vue&type=style&index=0&id=82c9f77e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c9f77e",
  null
  
)

export default component.exports